import React from 'react';

function TextToHTML({ text }) {
  return <div dangerouslySetInnerHTML={{ __html: text }} />;
}

export default TextToHTML;
